"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsFilterNotApplied = void 0;
// (C) 2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var model_1 = require("../../../../model");
var WARNING_FILTER_NOT_APPLIED = "gdc.aqe.not_applied_filter.report";
function useIsFilterNotApplied(widget, displayFormRef) {
    var execResult = model_1.useDashboardSelector(model_1.selectExecutionResultByRef(sdk_model_1.widgetRef(widget)));
    var allWarnings = execResult === null || execResult === void 0 ? void 0 : execResult.warnings;
    var dfMap = model_1.useDashboardSelector(model_1.selectAttributeFilterDisplayFormsMap);
    var df = dfMap.get(displayFormRef);
    if (!df) {
        return true;
    }
    if (!(allWarnings === null || allWarnings === void 0 ? void 0 : allWarnings.length)) {
        return false;
    }
    return allWarnings
        .filter(function (warning) { return warning.warningCode === WARNING_FILTER_NOT_APPLIED; })
        .some(function (warning) { var _a; return (_a = warning.parameters) === null || _a === void 0 ? void 0 : _a.some(function (param) { return sdk_model_1.isObjRef(param) && sdk_model_1.areObjRefsEqual(param, df.attribute); }); });
}
exports.useIsFilterNotApplied = useIsFilterNotApplied;
//# sourceMappingURL=useIsFilterNotApplied.js.map